export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门视频', href: '#media' },
  { label: '热度榜单', href: '#ranking' },
  { label: '网友热评', href: '#comments' },
  { label: '焦点专题', href: '#carousel' },
  { label: '联系我们', href: '#contact' },
  { label: '平台特色', href: '#features' },
];

export const indexItems = [
  {
    title: '明星塌房实录',
    subtitle: '最新翻车现场',
    desc: '本周娱乐圈最劲爆的明星翻车事件全盘点，从顶流到老戏骨无一幸免',
    icon: 'ri-alert-line',
    color: 'bg-primary-500',
    tag: 'HOT',
  },
  {
    title: '综艺内幕揭秘',
    subtitle: '幕后真相曝光',
    desc: '热门综艺不为人知的暗箱操作与剧本内幕，嘉宾关系大起底',
    icon: 'ri-tv-2-line',
    color: 'bg-accent-500',
    tag: 'NEW',
  },
  {
    title: '网红黑料深扒',
    subtitle: '人设崩塌现场',
    desc: '当红网红真实面目大揭露，从学历造假到私生活混乱全记录',
    icon: 'ri-user-search-line',
    color: 'bg-primary-500',
    tag: '爆',
  },
  {
    title: '影视圈潜规则',
    subtitle: '行业黑幕全曝光',
    desc: '影视行业不为人知的选角、投资与利益交换内幕深度报道',
    icon: 'ri-film-line',
    color: 'bg-accent-500',
    tag: '热',
  },
  {
    title: '音乐圈暗流涌动',
    subtitle: '抄袭与代笔疑云',
    desc: '热门单曲背后的创作争议，知名音乐人被指抄袭证据链盘点',
    icon: 'ri-music-line',
    color: 'bg-primary-500',
    tag: 'NEW',
  },
  {
    title: '直播带货乱象',
    subtitle: '假货翻车合集',
    desc: '头部主播带货翻车瞬间全记录，假货、虚假宣传逐一实锤',
    icon: 'ri-live-line',
    color: 'bg-accent-500',
    tag: 'HOT',
  },
  {
    title: '体育圈惊天大瓜',
    subtitle: '赛场内外猛料',
    desc: '体育明星私生活大起底，从恋爱绯闻到商业纠纷全面曝光',
    icon: 'ri-basketball-line',
    color: 'bg-primary-500',
    tag: '爆',
  },
  {
    title: '饭圈风云实录',
    subtitle: '粉丝大战全记录',
    desc: '各大粉丝群体之间的明争暗斗，从控评到线下冲突完整梳理',
    icon: 'ri-heart-pulse-line',
    color: 'bg-accent-500',
    tag: '热',
  },
];

export const mediaItems = [
  {
    title: '当红小生疑似恋情曝光，深夜与神秘女子同返公寓',
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20entertainment%20news%20visual%20with%20warm%20coral%20gradient%2C%20geometric%20shapes%2C%20soft%20lighting%2C%20editorial%20style%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition%2C%20clean%20lines%2C%20minimalist%20design&width=800&height=450&seq=media-card-01&orientation=landscape',
    views: '128.6万',
    date: '2小时前',
    tag: '独家',
    tagColor: 'bg-primary-500',
  },
  {
    title: '某女星片场耍大牌全程被拍，导演现场发飙怒斥',
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20film%20set%20theme%20with%20warm%20amber%20and%20deep%20red%20gradients%2C%20geometric%20composition%2C%20editorial%20photography%20style%2C%20dramatic%20lighting%2C%20cinematic%20mood%2C%20clean%20sophisticated%20aesthetic&width=800&height=450&seq=media-card-02&orientation=landscape',
    views: '96.3万',
    date: '5小时前',
    tag: '热议',
    tagColor: 'bg-accent-500',
  },
  {
    title: '知名综艺节目录制现场突发意外，嘉宾当场翻脸离场',
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20television%20studio%20theme%20with%20warm%20coral%20and%20dark%20tones%2C%20geometric%20shapes%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20clean%20composition%2C%20modern%20broadcast%20aesthetic&width=800&height=450&seq=media-card-03&orientation=landscape',
    views: '215.7万',
    date: '8小时前',
    tag: '爆款',
    tagColor: 'bg-primary-500',
  },
];

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20with%20warm%20coral%20tones%2C%20geometric%20style%2C%20clean%20lines%2C%20modern%20design%2C%20subtle%20gradient%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    nickname: '吃瓜一线猹',
    time: '10分钟前',
    content: '这个瓜我追了三天了，终于等到实锤！建议大家都去看看原视频，真的太精彩了，当事人估计现在后悔死了吧哈哈哈',
    likes: 3268,
    badge: '铁粉',
    badgeColor: 'bg-primary-500',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20with%20amber%20warm%20tones%2C%20geometric%20style%2C%20clean%20lines%2C%20modern%20design%2C%20soft%20gradient%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    nickname: '娱乐圈观察员',
    time: '25分钟前',
    content: '作为业内人，我只能说这篇扒得很到位。很多细节连我都不知道，博主的信息渠道确实够硬，关注了！',
    likes: 1892,
    badge: '达人',
    badgeColor: 'bg-accent-500',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20with%20warm%20rose%20tones%2C%20geometric%20style%2C%20clean%20lines%2C%20modern%20design%2C%20subtle%20gradient%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    nickname: '八卦小能手',
    time: '1小时前',
    content: '我就说之前总觉得哪里不对劲！原来背后有这么多故事，建议出一个系列专题，我第一个追更！',
    likes: 4215,
    badge: '活跃',
    badgeColor: 'bg-secondary-500',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20with%20terracotta%20tones%2C%20geometric%20style%2C%20clean%20lines%2C%20modern%20design%2C%20soft%20gradient%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    nickname: '爆料君在此',
    time: '2小时前',
    content: '网站更新速度确实快，全网第一个爆出来的就是这里。已经推荐给身边所有朋友了，吃瓜必备！',
    likes: 2743,
    badge: '老粉',
    badgeColor: 'bg-primary-500',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20with%20warm%20copper%20tones%2C%20geometric%20style%2C%20clean%20lines%2C%20modern%20design%2C%20soft%20gradient%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    nickname: '理性吃瓜群众',
    time: '3小时前',
    content: '虽然瓜很大但建议大家理性看待，等待更多证据。不过话说回来，这个网站的内容质量确实比别家高出一截！',
    likes: 1567,
    badge: '理性',
    badgeColor: 'bg-accent-500',
  },
];

export const aboutContent = {
  title: '关于51吃瓜黑料网',
  subtitle: '全网最硬核的娱乐八卦聚合平台',
  description: '51吃瓜黑料网成立于2023年，是国内领先的娱乐八卦资讯聚合平台。我们专注于为中文互联网用户提供最新、最全、最真实的娱乐黑料、明星八卦与网曝猛料。平台汇聚全网100+信息源，7×24小时不间断更新，确保用户第一时间获取最新鲜的娱乐资讯。',
  highlights: [
    { icon: 'ri-shield-check-line', label: '安全访问', desc: '多重加密保障，匿名浏览不留痕' },
    { icon: 'ri-flashlight-line', label: '极速更新', desc: '全网热点实时追踪，快人一步' },
    { icon: 'ri-global-line', label: '全源覆盖', desc: '100+信源聚合，一网打尽所有猛料' },
  ],
};

export const carouselItems = [
  {
    title: '2026上半年娱乐圈翻车大全',
    desc: '从年初到现在，娱乐圈已经上演了数十场大型翻车现场。我们按时间线梳理了每一个爆款事件的前因后果，以及背后的利益链条。从顶流塌房到老戏骨争议，从综艺黑幕到电影节猫腻，这篇文章让你一次看过瘾。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20coral%20and%20deep%20red%20gradients%2C%20geometric%20shapes%2C%20cinematic%20lighting%2C%20modern%20magazine%20cover%20style%2C%20dramatic%20mood%2C%20sophisticated%20design&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    tagColor: 'bg-primary-500',
    reads: '358.2万',
  },
  {
    title: '深度揭秘：综艺节目背后的剧本工厂',
    desc: '你看到的每一个"意外"和"冲突"，可能都是编剧团队精心设计的剧本。本文深入调查了国内主流综艺的编剧团队运作模式，揭露节目组如何通过人设设计、矛盾制造、剪辑操控来博取收视率。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20television%20production%20theme%20with%20amber%20and%20warm%20gold%20gradients%2C%20geometric%20patterns%2C%20editorial%20magazine%20style%2C%20dramatic%20studio%20lighting%2C%20sophisticated%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '深度报道',
    tagColor: 'bg-accent-500',
    reads: '247.6万',
  },
  {
    title: '直播带货圈的灰色产业链全起底',
    desc: '刷单、假货、虚假宣传——直播带货繁荣表象下的暗流涌动。我们历时三个月调查，揭开了头部主播与供应链之间不为人知的利益输送链条，以及平台方睁一只眼闭一只眼的默许态度。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20commerce%20theme%20with%20warm%20coral%20and%20dark%20moody%20gradients%2C%20geometric%20shapes%2C%20editorial%20style%2C%20modern%20design%2C%20sophisticated%20lighting&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '调查报道',
    tagColor: 'bg-primary-500',
    reads: '412.9万',
  },
  {
    title: '饭圈文化二十年：从追星到战争的演变',
    desc: '从早期的贴吧应援到如今的数据战争，饭圈文化在过去二十年经历了怎样的蜕变？我们通过大量采访和数据梳理，呈现了中国饭圈从单纯追星到商业化的完整演变路径，以及其对社会文化的深远影响。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fan%20culture%20theme%20with%20warm%20amber%20and%20rose%20gradients%2C%20geometric%20heart%20shapes%2C%20editorial%20magazine%20style%2C%20soft%20dramatic%20lighting%2C%20modern%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '文化观察',
    tagColor: 'bg-accent-500',
    reads: '189.4万',
  },
];

export const appContent = {
  title: '随时随地，吃瓜不停',
  subtitle: '扫码访问移动版，不错过任何一条猛料',
  description: '51吃瓜黑料网移动版全面适配手机端，无论你在通勤路上还是午休间隙，打开手机即可浏览最新八卦。界面简洁流畅，加载速度飞快，让你吃瓜永远快人一步。',
  features: ['手机浏览器直接访问，无需下载', '界面自适应，横竖屏自动适配', '省流量模式，图片智能压缩', '推送提醒，大瓜不错过'],
  qrImage: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20QR%20code%20design%20with%20warm%20coral%20geometric%20pattern%2C%20clean%20minimalist%20style%2C%20dark%20background%20with%20warm%20accent%2C%20tech%20aesthetic&width=400&height=400&seq=qr-code-app&orientation=squarish',
};

export const topicItems = [
  { name: '明星塌房', heat: '982.3万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '综艺黑幕', heat: '756.8万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '网红翻车', heat: '654.2万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '影视潜规则', heat: '541.6万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '直播假货', heat: '489.3万', trend: 'hot', icon: 'ri-fire-line', color: 'text-accent-500' },
  { name: '恋爱绯闻', heat: '467.1万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '人设崩塌', heat: '423.7万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '饭圈大战', heat: '398.4万', trend: 'hot', icon: 'ri-fire-line', color: 'text-accent-500' },
  { name: '片酬争议', heat: '356.2万', trend: 'up', icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  { name: '合同纠纷', heat: '312.5万', trend: 'new', icon: 'ri-sparkling-line', color: 'text-secondary-500' },
  { name: '解约风波', heat: '287.9万', trend: 'new', icon: 'ri-sparkling-line', color: 'text-secondary-500' },
];

export const updateItems = [
  {
    time: '10分钟前',
    title: '某选秀节目冠军被曝学历造假，校方回应称将展开调查',
    tag: '突发',
    tagColor: 'bg-primary-500',
  },
  {
    time: '28分钟前',
    title: '知名导演新片被指抄袭，网友晒出逐帧对比图实锤',
    tag: '热议',
    tagColor: 'bg-accent-500',
  },
  {
    time: '1小时前',
    title: '直播界两大顶流隔空互怼，疑似因争夺品牌代言引发',
    tag: 'NEW',
    tagColor: 'bg-primary-500',
  },
  {
    time: '2小时前',
    title: '某女团成员深夜发文暗示退队，粉丝集体炸锅',
    tag: '重磅',
    tagColor: 'bg-primary-500',
  },
  {
    time: '3小时前',
    title: '综艺录制现场工作人员爆料：嘉宾都是按剧本在演',
    tag: '独家',
    tagColor: 'bg-accent-500',
  },
  {
    time: '5小时前',
    title: '影视公司老板涉嫌洗钱被带走调查，旗下艺人纷纷切割',
    tag: '突发',
    tagColor: 'bg-primary-500',
  },
  {
    time: '7小时前',
    title: '知名歌手演唱会假唱被实锤，观众发长文控诉退票无门',
    tag: '热议',
    tagColor: 'bg-accent-500',
  },
  {
    time: '9小时前',
    title: '某顶流男星被拍到从精神科诊所出来，粉丝忧心忡忡',
    tag: 'NEW',
    tagColor: 'bg-primary-500',
  },
  {
    time: '12小时前',
    title: '网络电影分账数据造假被央视点名，行业或将迎来整顿',
    tag: '重磅',
    tagColor: 'bg-primary-500',
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流被曝婚内出轨多人，时间线完整梳理', heat: '1286.5万', change: 'new', changeIcon: 'ri-sparkling-line' },
  { rank: 2, title: '综艺导演被揭老底：那些年他潜规则过的女艺人', heat: '1102.3万', change: 'up', changeIcon: 'ri-arrow-up-line' },
  { rank: 3, title: '网红直播中自爆造假：我的百万粉丝都是买的', heat: '987.6万', change: 'up', changeIcon: 'ri-arrow-up-line' },
  { rank: 4, title: '某知名制片人深夜发长文，揭露影视圈洗钱套路', heat: '876.4万', change: 'down', changeIcon: 'ri-arrow-down-line' },
  { rank: 5, title: '当红小生被曝欠债千万不还，债主公开讨债录音', heat: '765.2万', change: 'up', changeIcon: 'ri-arrow-up-line' },
  { rank: 6, title: '某女星与经纪公司对簿公堂，合同纠纷细节曝光', heat: '654.8万', change: 'new', changeIcon: 'ri-sparkling-line' },
];

export const contactContent = {
  title: '联系我们',
  subtitle: '有料你就来，一起让真相浮出水面',
  description: '如果你有独家爆料、内幕消息或行业黑料，欢迎通过以下方式联系我们。我们承诺严格保护爆料人隐私，匿名处理所有信息来源。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@51chigua.com', color: 'bg-primary-500' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '51吃瓜黑料网', color: 'bg-accent-500' },
    { icon: 'ri-shield-check-line', label: '匿名投稿', value: '点击使用加密通道', color: 'bg-primary-500' },
  ],
};

export const cardItems = [
  {
    title: '三年跟拍，揭开横店群演的真实生存状态',
    desc: '光鲜亮丽的影视剧背后，那些没有姓名、没有台词的群演们过着怎样的生活？',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20film%20set%20behind%20scenes%20theme%20with%20warm%20coral%20gradients%2C%20geometric%20composition%2C%20editorial%20style%2C%20soft%20cinematic%20lighting%2C%20modern%20magazine%20layout&width=800&height=500&seq=card-01&orientation=landscape',
    date: '2026-07-28',
    tag: '深度报道',
    tagColor: 'bg-primary-500',
  },
  {
    title: '从素人到顶流：一个网红的自我包装全流程拆解',
    desc: '背后的MCN机构如何将一个普通人打造成为千万粉丝的大网红？',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20influencer%20theme%20with%20amber%20warm%20gradients%2C%20geometric%20shapes%2C%20editorial%20style%2C%20modern%20photography%2C%20clean%20composition&width=800&height=500&seq=card-02&orientation=landscape',
    date: '2026-07-26',
    tag: '行业揭秘',
    tagColor: 'bg-accent-500',
  },
  {
    title: '资本博弈：影视公司背后的金融大鳄与对赌协议',
    desc: '当明星成为金融产品，背后的资本游戏远比银幕上的故事更精彩。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20finance%20and%20entertainment%20theme%20with%20warm%20coral%20and%20dark%20gradients%2C%20geometric%20patterns%2C%20editorial%20magazine%20style%2C%20sophisticated%20lighting&width=800&height=500&seq=card-03&orientation=landscape',
    date: '2026-07-24',
    tag: '财经观察',
    tagColor: 'bg-primary-500',
  },
  {
    title: '音乐节背后的生意经：票价翻三倍的钱都进了谁的口袋',
    desc: '一场音乐节的门票收入动辄上亿，艺人和主办方各自能分到多少？',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20festival%20theme%20with%20warm%20amber%20and%20gold%20gradients%2C%20geometric%20shapes%2C%20editorial%20style%2C%20dramatic%20stage%20lighting&width=800&height=500&seq=card-04&orientation=landscape',
    date: '2026-07-22',
    tag: '产业分析',
    tagColor: 'bg-accent-500',
  },
  {
    title: '独家对话退圈艺人：为什么我选择离开这个名利场',
    desc: '一位曾经红极一时的演员，讲述他退出娱乐圈的真实原因与心路历程。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20portrait%20and%20storytelling%20theme%20with%20warm%20coral%20gradients%2C%20geometric%20composition%2C%20editorial%20style%2C%20soft%20emotional%20lighting&width=800&height=500&seq=card-05&orientation=landscape',
    date: '2026-07-20',
    tag: '独家专访',
    tagColor: 'bg-primary-500',
  },
  {
    title: '流量密码：那些靠炒作起家的营销号是如何运作的',
    desc: '揭秘营销号团队的日常：选题策划、素材搜集、情绪煽动到流量变现的完整闭环。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20media%20and%20marketing%20theme%20with%20amber%20warm%20gradients%2C%20geometric%20shapes%2C%20editorial%20style%2C%20modern%20tech%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
    date: '2026-07-18',
    tag: '行业观察',
    tagColor: 'bg-accent-500',
  },
];

export const faqItems = [
  {
    question: '51吃瓜黑料网的内容都是真实的吗？',
    answer: '我们致力于提供真实可靠的娱乐资讯。所有内容均来源于公开报道、网友投稿和行业内部消息，并通过多方信源交叉验证后发布。对于尚在核实中的信息，我们会明确标注"待证实"。',
  },
  {
    question: '网站内容每天更新多少次？',
    answer: '51吃瓜黑料网实行7×24小时不间断更新制，编辑团队全天候监控全网热点。重大突发事件在15分钟内即可发布快讯，深度专题报道则会在24-48小时内完成制作。平均每日更新内容超过200条。',
  },
  {
    question: '如何保证访问安全和隐私？',
    answer: '本站采用全站HTTPS加密传输，不记录用户浏览历史和个人信息。建议使用浏览器的无痕模式访问，进一步保障您的隐私安全。我们不会向任何第三方提供用户数据。',
  },
  {
    question: '我可以投稿或提供爆料线索吗？',
    answer: '当然可以！我们非常欢迎网友提供独家爆料和行业内部消息。请通过页面底部的联系方式发送邮件或使用匿名加密通道提交。我们郑重承诺：严格保护爆料人隐私，绝不透露信息来源。',
  },
  {
    question: '网站是否需要注册登录才能浏览？',
    answer: '完全不需要。51吃瓜黑料网坚持开放浏览原则，所有内容均可直接访问，无需注册账号或登录。我们相信好的内容不需要门槛，随时随地，想看就看。',
  },
  {
    question: '为什么有些内容的链接打不开？',
    answer: '由于网络环境的复杂性，部分外部链接可能因各种原因暂时无法访问。遇到这种情况，建议您稍后重试或使用我们的备用地址。本站首页和各模块内容始终保持稳定可访问。',
  },
];

export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '极速响应',
    desc: '重大娱乐事件发生后15分钟内即可发布首条快讯，确保你始终掌握第一手资讯，吃瓜永远比别人快一步。',
    color: 'bg-primary-500',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容',
    desc: '聚合全网100+信息源，涵盖明星八卦、综艺内幕、影视圈潜规则、网红翻车等全品类娱乐黑料，一站打尽。',
    color: 'bg-accent-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '全站HTTPS加密，无需注册登录，支持匿名浏览。严格保护用户隐私，不追踪、不记录、不泄露任何浏览数据。',
    color: 'bg-primary-500',
  },
];

export const footerData = {
  description: '51吃瓜黑料网——全网最新最全的娱乐八卦黑料聚合平台。提供51吃瓜黑料网址、51吃瓜官网全网最新入口，51吃瓜网站入口一键直达。7×24小时实时更新，安全访问，吃瓜必备。',
  quickLinks: [
    { label: '热门视频', href: '#media' },
    { label: '热度榜单', href: '#ranking' },
    { label: '焦点专题', href: '#carousel' },
    { label: '网友热评', href: '#comments' },
    { label: '联系我们', href: '#contact' },
    { label: '常见问答', href: '#faq' },
  ],
  topics: [
    { label: '明星塌房', href: '#topics' },
    { label: '综艺黑幕', href: '#topics' },
    { label: '网红翻车', href: '#topics' },
    { label: '直播假货', href: '#topics' },
    { label: '饭圈大战', href: '#topics' },
  ],
};